
import { defineComponent } from 'vue'

// components
import Tabs from '@/common/components/UI/Tabs/index.vue'

// types
import { TabT } from '@/core/types/components.types'

export default defineComponent({
    components: {
        tabs: Tabs,
    },
    setup() {
        const tabs: TabT[] = [
            { id: 1, name: 'Стандартный 2024', path: '/tariffs' },
            { id: 2, name: 'Стандартный 2025', path: '/tariffs/standart-2025' },
            { id: 2, name: 'Индивидуальный', path: '/tariffs/individual' },
            { id: 3, name: 'Уникальный', path: '/tariffs/unique' },
        ]

        return { tabs }
    },
})
